import AppBgImage from "../../assets/images/daam_bg_image.png";
import AppBgImage2 from "../../assets/images/daam_bg_image2.png";
import AppBgImage3 from "../../assets/images/daam_bg_image3.png";

export const STORAGE_KEYS = {
  TOKEN: "daam-web-app-token",
  LANGUAGE: "language",
  SHOW_LOADING: "show_loading",
  SHOW_GAME_RULES: "show_game_rules",
  SHOULD_FETCH_PLAYER_AGAIN: "should-fetch_player-again",
};

export const MAIN_FONT_FAMILY = "IBM Plex Sans Arabic";

export const APP_BG_IMAGE = AppBgImage;
export const APP_BG_IMAGE2 = AppBgImage2;
export const APP_BG_IMAGE3 = AppBgImage3;

export const ENCRYPTION_SECRET_KEY =
  "mFYHMm1T2cNwJhKu1eVs9qkb9zQqnbeUybzOSYX3Nng=";
